
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-chat",
      function () {
        return require("private-next-pages/live-chat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-chat"])
      });
    }
  